import React from 'react';
import { motion } from 'framer-motion';

const Process = () => {
  const steps = [
    { name: 'Scope', desc: 'We define exactly what needs to be built and why. No fluff, just the roadmap.' },
    { name: 'Build', desc: 'Rapid development with weekly updates. You see the progress as it happens.' },
    { name: 'Ship & Improve', desc: 'We launch and then iterate based on real usage. We don\'t just disappear.' },
  ];

  return (
    <section className="py-24 bg-[#07113a] border-y border-[#344271]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold text-white mb-6">Three-step process</h2>
        </div>

        <div className="grid md:grid-cols-3 gap-12">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ delay: index * 0.1 }}
              viewport={{ once: true }}
              className="relative"
            >
              <div className="text-6xl font-black text-[#3b82f6]/10 absolute -top-8 -left-4 select-none">0{index + 1}</div>
              <div className="relative z-10">
                <h4 className="text-2xl font-bold text-white mb-4">{step.name}</h4>
                <p className="text-[#e2e8f0]/80 leading-relaxed text-lg font-medium">{step.desc}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;